import React, { useEffect, useState } from 'react';
import { useDrag } from 'react-dnd';
import ReactPlayer from 'react-player'
import { H1, Image } from '../../../AbstractElements';
import { dynamicImage } from '../../../Service';
import { PageFile } from './ReportCreator';
interface DraggableElementProps {
  element: Element;
  selectedElement: Element | null;
  index: number;
  pageFiles: PageFile[];
  setSelectedElement: (element: Element) => void;
}

interface Element {
  id: number;
  type: string;
  subject: string;
  description: string;
  file_id?: string;
}

// CollapsibleText component as previously defined or imported
const CollapsibleText: React.FC<{ subject: string, description: string }> = ({ subject, description }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div>
      <div onClick={toggleOpen} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <div style={{
          transform: !isOpen ? 'rotate(0deg)' : 'rotate(90deg)',
          transition: 'transform 0.3s',
          marginRight: '5px'
        }}>
          ▶{/* This is the triangle icon */}
        </div>
        <strong>{subject || "Default Text"}</strong>
      </div>
      {isOpen && <div style={{ paddingLeft: '20px', marginTop: '5px' }}>
        {description || "This is just set as default."}
      </div>}
    </div>
  );
};

const DraggableElement: React.FC<DraggableElementProps> = ({ pageFiles, selectedElement, element, setSelectedElement, ...props }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'element',
    item: { id: element.id },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  });


  const [fileUrl, setFileUrl] = useState('')
  const [fileMetaData, setFileMetaData] = useState({ duration: 0 });
  const [pageFile, setPageFile] = useState<File | null | undefined>()

  useEffect(() => {
    if (element?.file_id) {
      const _file = pageFiles.find(f => f.id === element.file_id)
      setPageFile(_file?.file?.file)
    }
    else
      setPageFile(null)
  }, [element?.file_id])

  useEffect(() => {
    if (pageFile instanceof File) {
      const _fileUrl = URL.createObjectURL(pageFile);
      setFileUrl(_fileUrl);

      // Create a video element to load metadata
      const videoElement = document.createElement('video');
      videoElement.preload = 'metadata';
      videoElement.onloadedmetadata = () => {
        setFileMetaData({
          duration: videoElement.duration
        });
        URL.revokeObjectURL(fileUrl); // Clean up the object URL after metadata is loaded
      };
      videoElement.src = fileUrl;
      // Clean up the object URL on component unmount
      return () => {
        URL.revokeObjectURL(fileUrl);
        videoElement.src = ""; // Prevent memory leaks by clearing the video source
      };
    } else {
      setFileUrl(""); // Reset video URL if the file is not valid
    }
  }, [pageFile]);

  return (
    <div id={`element-${element.id}`} className='my-3 mx-4' ref={drag} style={{
      position: 'relative', opacity: isDragging ? 0.5 : 1, cursor: 'move',
      border: '1px solid gray', color: '#fff', padding: '10px', boxSizing: 'border-box'
    }} onMouseDown={(e) => { setSelectedElement(element) }}>
      {element.type === 'dropdown' ?
        <CollapsibleText subject={element.subject} description={element.description} />
        : null}
      {element.type === 'text' ?
        <div>{element.description || "This is just set as default."}</div>
        : null}
      {element.type === 'video' ?
        fileUrl ?
          <>
            {selectedElement !== element && <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }} onMouseDown={() => { setSelectedElement(element) }}></div>}
            <ReactPlayer
              url={fileUrl}
              controls
              width='100%'
              height={"auto"}
              type={pageFile?.type}
            />
          </>
          :
          <>
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }} onMouseDown={() => { setSelectedElement(element) }}></div>
            <video src="" controls width={"100%"}></video>
          </>
        : null}
      {element.type === 'image' ?
        fileUrl ?
          <img
            src={fileUrl}
            width='100%'
            height={"auto"}
            alt=""
          /> :
          <div className='d-flex justify-content-center'>
            <Image className="img-fluid"
              src={dynamicImage("logo/gallery.png")}
              alt="logo"
              style={{
                width: "50%",
                marginInline: 'auto',
              }} />
          </div>
        : null}
    </div>

  );
};

export default DraggableElement;
